module.exports = __webpack_public_path__ + "static/media/sales.45974896.svg";